import type { UserAction } from '@/features/proactive-agents/proactive-agents-types';

// What the page calls each action: `label` on its button, and `name` in the confirm dialog's title and the results heading
export const USER_ACTIONS: Record<
  UserAction,
  { label: string; name: (agent: string) => string }
> = {
  'set-default': {
    label: 'Set as default',
    name: (agent) => `Set ${agent} as default`,
  },
  'clear-default': { label: 'Clear override', name: () => 'Clear override' },
  pause: { label: 'Pause', name: (agent) => `Pause ${agent}` },
  resume: { label: 'Resume', name: (agent) => `Resume ${agent}` },
  delete: { label: 'Delete chat', name: (agent) => `Delete chat of ${agent}` },
};

// Once the chat of an agent that can be chosen as a default is deleted, the action that starts that agent again: Clear override
// for the code default, Set as default for any other agent
export const restartActionLabel = (agent: string, codeDefault: string) =>
  USER_ACTIONS[agent === codeDefault ? 'clear-default' : 'set-default'].label;
